import { defineMessages } from 'react-intl';

export default defineMessages({
    label: {
        id: 'components.projectInformation.ShowPreviousVersionSwitcher.label',
        defaultMessage: 'Show previous version', // DE: Vorherige Version anzeigen
    },
});
